// client/src/contexts/LearningContext.tsx

import React, { createContext, useState, useContext, ReactNode } from "react";

export interface LearningState {
  currentCourseId: string | null;
  progress: number; // e.g., percentage of course completed
  resources: string[]; // Could be URLs or resource IDs
}

interface LearningContextType {
  learningState: LearningState;
  setLearningState: (state: LearningState) => void;
  updateProgress: (progress: number) => void;
}

const defaultLearningState: LearningState = {
  currentCourseId: null,
  progress: 0,
  resources: [],
};

const LearningContext = createContext<LearningContextType | undefined>(undefined);

export const LearningProvider = ({ children }: { children: ReactNode }) => {
  const [learningState, setLearningState] = useState<LearningState>(defaultLearningState);

  const updateProgress = (progress: number) => {
    setLearningState((prevState) => ({ ...prevState, progress }));
  };

  return (
    <LearningContext.Provider value={{ learningState, setLearningState, updateProgress }}>
      {children}
    </LearningContext.Provider>
  );
};

export const useLearning = (): LearningContextType => {
  const context = useContext(LearningContext);
  if (!context) {
    throw new Error("useLearning must be used within a LearningProvider");
  }
  return context;
};

export {};